import { forwardRef, type PropsWithChildren } from 'react'
import classNames from 'clsx'
// eslint-disable-next-line boundaries/element-types
import { Link as RouterLink, type TLinkProps as TRouterLinkProps } from '@muse-web/router'
import styles from './Link.module.css'

export type TLinkProps = PropsWithChildren<
    {
        variant?: 'primary' | 'ghost'
        size?: 'sm' | 'md' | 'lg'
    } & Omit<TRouterLinkProps, 'children' | 'replace' | 'isForceHard'>
>

export const Link = forwardRef<HTMLAnchorElement, TLinkProps>(
    ({ children, className, variant = 'ghost', size = 'md', ...props }, ref) => {
        const linkClasses = classNames(
            styles.link,
            styles[`link-${variant}`],
            styles[`link-${size}`],
            className,
        )

        return (
            <RouterLink ref={ref} className={linkClasses} {...props}>
                {children}
            </RouterLink>
        )
    },
)
